import Latex from '../../../../../apps/frontend/src/components/global/Latex';

const getQuestionText = (currentSolution) => {
  const isInputQuestion = currentSolution?.questionId?.correctValue?.trim().length > 0;
  let correctOption;
  if (isInputQuestion) {
    correctOption = currentSolution?.questionId?.correctValue?.trim();
  } else {
    correctOption = currentSolution?.questionId?.options?.find((opt) => opt.isCorrect);
  }

  const splittedText = currentSolution?.questionId?.question?.text?.split('<op_')?.length - 1;
  let finalText = currentSolution?.questionId?.question?.text;
  finalText = finalText.replace(
    `<op_${index}>`,
    `<span style="text-decoration: underline; font-weight: bold;">${
      isInputQuestion ? correctOption : correctOption?.text
    }</span>`,
  );
  // Replace text in finalText matches <op_*>
  for (let qIndex = 0; qIndex < splittedText; qIndex++) {
    const element = currentSolution?.questionId?.question?.text?.split('<op_')[qIndex + 1];
    const optionIndex = element?.split('>')[0];
    finalText = finalText?.replace(`<op_${optionIndex}>`, '________');
  }

  const enteredAnswer = isInputQuestion ? currentSolution?.markedOptions?.[0]?.optionId : null;

  return (
    <>
      <Latex>{finalText}</Latex>
      {isInputQuestion && enteredAnswer && (
        <p className="mt-3">
          <strong>You Entered:</strong> {enteredAnswer}
        </p>
      )}
    </>
  );
};

export default getQuestionText;
